module.exports = __webpack_public_path__ + "img/10-full.825c4dc3.jpeg";